import React, {useState} from 'react';
import {BsCheckCircleFill, BsCircle} from "react-icons/bs";
import {Button, Checkbox, Accordion} from "@mui/material";
// import paths from "../../paths.json";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';

import {FiChevronDown, FiChevronUp} from 'react-icons/fi';
import {styled} from "@mui/material/styles";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Fade from 'react-reveal/Fade';
import {BiInfoCircle} from 'react-icons/bi';
import {IoClose} from "react-icons/io5";
import { useTranslation } from 'react-i18next';


const LightTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

const AccordionSummary = styled((props) => (
   <MuiAccordionSummary
      {...props}
   />
))(({theme}) => ({
   backgroundColor: '#FFFFFFF',
   flexDirection: 'flex-end',
   marginBottom: '0px',
   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      // transform: 'rotate(90deg)',
      margin: '0px'

   },
   '& .MuiAccordionSummary-content': {
      // marginLeft: theme.spacing(1),
      // fontWeight: '600',
      // fontSize: '14px'
   },
   '& .css-1elwnq4-MuiPaper-root-MuiAccordion-root:before': {
      background: 'none', // Remove the background color
   },
   '& .MuiPaper-root .MuiAccordion-root .Mui-expanded': {
      margin: '0px',
      backgroundColor: 'pink'
   },
   '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '0px !important'
   }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
   padding: theme.spacing(0),
   backgroundColor: '#FFFFFF',
}));


const TempItem = ({icon, checked, title, tooltipText, tooltipLink, description, buttonText, buttonAction, customComponent, showExitMark}) => {
   const [isOpen, setIsOpen] = useState(false);

   const toggleAccordion = () => {
      setIsOpen(!isOpen);
   };

   return (

      <>

               <div
                  style={{
                     position: 'relative',
                     display: 'flex',
                     padding: '30px 0px',
                     borderRadius: '8px',
                     alignItems: 'center',
                     margin: '0px auto 25px',
                     border: '1px solid #E4EBF6',
                     // borderTop: title === "Share your waitlist" || checked === true ? '' : '1px solid #D3DCE7',
                     boxSizing: 'border-box',
                     backgroundColor: '#FFFFFF',
                     width: '100%',
                     // borderRadius: '8px',
                     // minHeight: '260px'
                  }}
               >

                  {
                     showExitMark ?
                        <div
                           style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              fontSize: '20px',
                              padding: '5px',
                           }}
                        >

                           <IoClose style={{color: '#AFBED3', cursor: 'default', backgroundColor: 'transparent'}}/>
                        </div>
                        : null

                  }




                  <div
                     style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '90%',
                        margin: 'auto'
                     }}
                  >
            <span style={{fontSize: '45px', textAlign: 'center',}}>
               {icon}
            </span>
                     <h2
                        style={{
                           fontSize: '18px',
                           fontWeight: 'bold',
                           color: 'black',
                           margin: '10px auto',
                           textAlign: 'center',
                        }}
                     >
                        {title}
                        {
                           tooltipLink !== null ?
                              <LightTooltip title={tooltipText}>
                              <span style={{marginLeft: '4px'}}
                                    >
                        <BiInfoCircle
                           style={{color: '#222222', verticalAlign: 'middle', marginTop: '-2px', cursor: 'pointer'}}
                        />
                      </span>
                              </LightTooltip>: null
                        }


                     </h2>

                     <p
                        style={{
                           fontSize: '15px',
                           margin: '0px 0px 5px 0px',
                           fontWeight: '500',
                           color: '#6E89AF',
                           textAlign: 'center',
                           lineHeight: '20px',
                        }}
                     >
                        {description}
                     </p>

                     {buttonText !== '' ?

                        <div style={{width: '100%', height: 'auto', display: 'flex'}}>
                           <Button variant="contained"
                                   disableElevation
                                   sx={{
                                      padding: '5px 10px',
                                      margin: '15px auto 0px auto',
                                      textAlign: 'center',
                                      borderRadius: '10px',
                                      textTransform: 'none',
                                      border: '2px var(--brand-color) solid',
                                      backgroundColor: 'var(--brand-color)',
                                      '&:hover': {
                                         backgroundColor: 'var(--brand-color-hover)',
                                         border: '2px var(--brand-color-hover) solid',
                                      }
                                   }}
                                   onClick={buttonAction}
                           >
                                    <span className="fa fa-search"
                                          style={{fontWeight: '600', fontSize: '13px'}}>{buttonText}</span>
                           </Button>
                        </div>
                        : null

                     }


                     {
                        customComponent !== null ?
                           <>
                              {customComponent}
                           </> : null


                     }

                  </div>
               </div>
      </>


   );
};

const JoinCommunity = (props) => {
   const { t } = useTranslation();

   return (
      <div style={{ width: '100%', margin: '20px auto 0px auto' }}>

         <TempItem
            icon={"👋"}
            title={t('dashboard.community.welcomeToYourCommunity')}
            tooltipLink={props.waitinglistToolTipLink}
            tooltipText={t('dashboard.home.onlyYouCanSee')}
            description={t('dashboard.community.yourCommunityDescription')}
            buttonText={''}
            // customComponent={props.firstCommunityComponent}
            showExitMark={false}
            // firstElement={true}
         />

         {/*<TempItem*/}
         {/*   icon={"✌️"}*/}
         {/*   checked={props.customChecked}*/}
         {/*   title={t('community.createFirstPost')}*/}
         {/*   tooltipLink={null}*/}
         {/*   tooltipText={"The first post is always the hardest. Enter your post at the top and select who can reply to your post. This box will disappear after you have submitted your first post."}*/}
         {/*   description="Kickstart your community by warmly welcoming members, sharing crucial updates, or simply sharing what's on your mind. "*/}
         {/*   buttonText={'Create your first post'}*/}
         {/*   buttonAction={props.firstCommunityPostAction}*/}
         {/*   // customComponent={props.firstCommunityComponent}*/}
         {/*   showExitMark={false}*/}
         {/*/>*/}

         {/*<TempItem*/}
         {/*   icon={"🤲️"}*/}
         {/*   checked={props.offeringChecked}*/}
         {/*   title={t('community.chooseYourOffering')}*/}
         {/*   tooltipLink={props.offeringToolTipLink}*/}
         {/*   // tooltipText={"Share your platform with your community. Whilst optional, our data suggests that the greater the waitlist, the greater the launch!"}*/}
         {/*   description="Choose your content offerings, membership tiers, and pricing to perfectly suit your audience and maximize membership success."*/}
         {/*   buttonText={''}*/}
         {/*   buttonAction={props.offeringButtonAction}*/}
         {/*   customComponent={props.offeringComponent}*/}
         {/*/>*/}

         {/*<TempItem*/}
         {/*   icon={"📁"}*/}
         {/*   checked={props.contentChecked}*/}
         {/*   title={t('community.uploadYourContent')}*/}
         {/*   tooltipLink={props.contentToolTipLink}*/}
         {/*   // tooltipText={"Share your platform with your community. Whilst optional, our data suggests that the greater the waitlist, the greater the launch!"}*/}
         {/*   description="The time has come to fill your platform with valuable content. Extend a friendly welcome to members, provide an insight into your offering, or showcase a collection of posts. A minimum of 6 pieces of content and 1 collection is required to launch."*/}
         {/*   buttonText={''}*/}
         {/*   buttonAction={props.contentButtonAction}*/}
         {/*   customComponent={props.contentComponent}*/}
         {/*/>*/}
         {/*<TempItem*/}
         {/*   icon={"🎉"}*/}
         {/*   checked={props.publishedChecked}*/}
         {/*   title={t('community.publishPlatform')}*/}
         {/*   tooltipLink={null}*/}

         {/*   // tooltipText={"Share your platform with your community. Whilst optional, our data suggests that the greater the waitlist, the greater the launch!"}*/}
         {/*   description="The simplest, most important, and last item on your checklist: When you're ready, publish your platform and begin delivering value to your community."*/}
         {/*   buttonText={''}*/}
         {/*   buttonAction={props.publishedButtonAction}*/}
         {/*   customComponent={props.publishComponent}*/}
         {/*/>*/}

         {/* We can add more or less items as needed*/}
      </div>
   );
};

export default JoinCommunity;
